import { BubbleMenu as BubbleMenuCore } from "@/components/ui/editor/core/components/bubble-menu";
import { useEditorContext } from "../rich-text-editor-provider";

export const BubbleMenu = () => {
  const { editor, openInlineMenu } = useEditorContext("Editor");
  if (!editor) return null;
  return <BubbleMenuCore editor={editor} openInlineMenu={openInlineMenu} />;
};
